module.exports = {
    data () {
        return {
            fromRoute: null
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fromRoute = from;
        })
    },

    methods: {
        handleBack (fallback) {
            if (!this.fromRoute || !this.fromRoute.name) {
                this.$router.push(fallback);
            } else {
                this.$router.back();
            }
        }
    }
}
